// extracted by mini-css-extract-plugin
export var actionButton = "_9m-1";
export var actionButtons = "_9m-2";
export var actions = "_9m-0";
export var aiUnread = "_9m-10";
export var alignCenter = "_9m-h";
export var backWrapper = "_9m-3";
export var cellContainer = "_9m-4";
export var checkboxContainer = "_9m-5";
export var contentContainer = "_9m-6";
export var contentHeader = "_9m-8";
export var conversationsTableWrapper = "_9m-s";
export var draftReplyBadgeContainer = "_9m-m";
export var dropdownItem = "_9m-b";
export var dropdownItemsContainer = "_9m-a";
export var dropdownTitle = "_9m-c";
export var errorIcon = "_9m-7";
export var filter = "_9m-d";
export var gray = "_9m-i";
export var headerActionButtons = "_9m-e";
export var headerCheckboxContainer = "_9m-f";
export var icon = "_9m-j";
export var menuContainer = "_9m-k";
export var noMoreTicketsIcon = "_9m-12";
export var noMoreTicketsSubText = "_9m-13";
export var oneLine = "_9m-l";
export var optionsButton = "_9m-n";
export var plus = "_9m-o";
export var portalButtonsWrapper = "_9m-g";
export var red = "_9m-p";
export var scrolledTop = "_9m-9";
export var search = "_9m-q";
export var selectedConversationsCount = "_9m-r";
export var spinner = "_9m-t";
export var strong = "_9m-u";
export var summaryCell = "_9m-v";
export var tableContainer = "_9m-11";
export var tagContainer = "_9m-w";
export var threeDots = "_9m-x";
export var twoLines = "_9m-y";
export var unread = "_9m-z";